import React from "react";
import ReactGA from "react-ga4";

const Section2 = () => {
  const buttonClick = () => {
    console.log("Button clicked Request a demo home")
    ReactGA.event({
      category: "button",
      action: "Request a demo button clicked",
      label: "Request a demo button home",
      value: 99,
      nonInteraction: true,
      transport: "xhr",
    });
  };

  return (
    <div className="w-full mt-16 grid grid-cols-1 md:grid-cols-2 gap-[34px] text-left px-2 overflow-auto text-42xl text-brand-color-primary font-inter">
      <div className="flex flex-col pt-0 px-0 box-border items-left justify-center">
        <div className="flex px-5 flex-col items-left justify-center">
          <b className="" style={{ fontSize: "35px" }}>
            Next-Gen
            <br /> AI-Powered Hospitality Suite
          </b>
          <div className="text-lgi mt-5 leading-[30px] text-gray-100 flex items-center shrink-0">
            Maximize success with smart pricing, PMS integration, and enhanced
            guest experiences for your accommodation business.
          </div>
        </div>
        <div className="text-mini leading-[28px] px-5 mt-5 text-darkslategray flex items-left shrink-0">
          Unlock Your Hospitality's Full Potential!
        </div>
        <a
          href="/signup"
          className="no-underline flex item-start md:justify-start justify-center mt-5"
        >
          <div className="rounded-41xl [background:linear-gradient(264.48deg,_#79f1a4,_#5bacf2)] shadow-[0px_5px_22.58px_rgba(50,_174,_137,_0.25)] p-3 py-4 md:ml-4 flex flex-col items-center justify-center text-center text-lg text-color-white">
            <div
              className="relative font-medium inline-block w-[171.09px] h-[26.83px] shrink-0"
              onClick={() => buttonClick()}
            >
              Request a Demo
            </div>
          </div>
        </a>
      </div>
      <div className="flex item-center">
        <img className="max-w-full h-auto" alt="" src="/right1@2x.png" />
      </div>
    </div>
  );
};

export default Section2;
